export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14296.9889366e.jpg";